"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("@material-ui/core/Button");
const styles_1 = require("@material-ui/core/styles");
const classnames_1 = require("classnames");
const ArcadePopupButton = ({ onSubmit, isDisabled, classes, title, className }) => ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: "primary", onClick: onSubmit, "aria-label": title, title: title, disabled: isDisabled, variant: 'contained', className: (0, classnames_1.default)(classes.button, className) }, { children: title })));
const styles = (theme) => (0, styles_1.createStyles)({
    button: {
        backgroundColor: `${theme.palette.secondary.main} !important`,
        color: `${theme.palette.primary.dark} !important`,
        boxShadow: '0 0 10px 0 #b3b9ff',
        borderColor: 'transparent',
        minWidth: '40%',
        [theme.breakpoints.down('sm')]: {
            width: '60%'
        },
        '&.Mui-disabled': {
            borderColor: 'transparent',
            backgroundColor: 'rgba(233, 236, 240, 1) !important',
            boxShadow: 'none',
            color: 'rgba(0, 0, 0, 0.82) !important'
        },
        '&:hover': {
            boxShadow: '0 0 10px 1px #b3b9ff',
            backgroundColor: '#e3d0a0'
        }
    }
});
exports.default = (0, styles_1.withStyles)(styles)((0, styles_1.withTheme)(ArcadePopupButton));
//# sourceMappingURL=ArcadePopupButton.js.map